/* wl-cart.js — Wuffy Lab cart drawer (clone Wuffes): opens in place after add-to-cart, header icon, upsells */
(function () {
  'use strict';
  if (window.__wlCartInit) { return; }
  window.__wlCartInit = true;

  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  ready(function () {
    var root = document.querySelector('[data-wl-cart]');
    var overlay = document.getElementById('wl-cart-overlay');
    if (!root || !overlay) return;

    var cfg = { labels: {}, upsells: [] };
    try { cfg = JSON.parse(document.querySelector('[data-wl-cart-config]').textContent) || cfg; } catch (e) {}
    var L = cfg.labels || {};
    var threshold = Number(root.getAttribute('data-threshold') || 0);
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var onCartPage = location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '');

    var fmt;
    try {
      var nf = new Intl.NumberFormat(root.getAttribute('data-locale') || 'fr', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' });
      fmt = function (c) { return nf.format(c / 100); };
    } catch (e) { fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }; }
    var tpl = function (s, m) { return String(s || '').replace(/\{(\w+)\}/g, function (x, k) { return m[k] !== undefined ? m[k] : x; }); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

    var el = {
      items: root.querySelector('[data-wl-cart-items]'),
      empty: root.querySelector('[data-wl-cart-empty]'),
      foot: root.querySelector('[data-wl-cart-foot]'),
      count: root.querySelector('[data-wl-cart-count]'),
      bar: root.querySelector('[data-wl-cart-bar]'),
      fill: root.querySelector('[data-wl-cart-fill]'),
      barText: root.querySelector('[data-wl-cart-bar-text]'),
      subtotal: root.querySelector('[data-wl-cart-subtotal]'),
      savings: root.querySelector('[data-wl-cart-savings]'),
      savingsVal: root.querySelector('[data-wl-cart-savings-val]'),
      upsell: root.querySelector('[data-wl-cart-upsell]'),
      upsellList: root.querySelector('[data-wl-cart-upsell-list]'),
      body: root.querySelector('[data-wl-cart-body]')
    };

    /* ---------- compare-at prices per variant (lazy, cached per product) ---------- */
    var compareCache = {}; /* variant id -> compare_at_price cents */
    var productLoads = {};
    var loadCompare = function (handle) {
      if (productLoads[handle]) return productLoads[handle];
      productLoads[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p && p.variants) p.variants.forEach(function (v) { compareCache[v.id] = v.compare_at_price || 0; }); })
        .catch(function () {});
      return productLoads[handle];
    };

    /* ---------- open / close ---------- */
    var lastFocus = null, lockY = 0;
    var isOpen = function () { return !root.hidden; };
    /* scroll lock: Horizon scrolls the body only < 990px (above, .page-wrapper scrolls) — iOS needs position:fixed */
    var lock = function () {
      document.body.classList.add('wl-cart-open');
      if (window.innerWidth < 990) { lockY = window.scrollY || 0; document.body.style.top = -lockY + 'px'; document.body.classList.add('wl-cart-lock'); }
    };
    var unlock = function () {
      var locked = document.body.classList.contains('wl-cart-lock');
      document.body.classList.remove('wl-cart-open', 'wl-cart-lock'); document.body.style.top = '';
      if (locked) window.scrollTo(0, lockY);
    };
    var open = function () {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      overlay.hidden = false; root.hidden = false; root.classList.remove('is-closing');
      lock();
      var c = root.querySelector('[data-wl-cart-close]'); if (c) c.focus({ preventScroll: true });
    };
    var close = function () {
      if (!isOpen()) return;
      root.classList.add('is-closing');
      setTimeout(function () {
        root.hidden = true; overlay.hidden = true; root.classList.remove('is-closing');
        unlock();
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }, 200);
    };
    root.querySelectorAll('[data-wl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

    /* header cart icons open the drawer instead of navigating */
    if (!onCartPage) {
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || a.closest('[data-wl-cart]')) return;
        var href = a.getAttribute('href') || '';
        if (href === cartUrl || href === cartUrl + '/' || /^\/cart\/?$/.test(href)) {
          e.preventDefault(); refresh().then(open, open);
        }
      });
    }

    /* ---------- API ---------- */
    var toast = function (msg) {
      var t = document.createElement('div'); t.className = 'wl-cart__toast wl-root'; t.textContent = msg;
      document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2600);
    };
    var api = function (path, body) {
      return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); });
    };
    var getCart = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    var refresh = function () { return getCart().then(render); };

    /* ---------- render ---------- */
    var planMeta = function (name) {
      var s = String(name || '');
      var w = /(\d+)\s*(week|semaine)/i.exec(s); var d = /(\d+(?:[.,]\d+)?)\s*%/.exec(s);
      return { weeks: w ? Number(w[1]) : 0, pct: d ? d[1].replace('.', ',') + ' %' : '' };
    };
    var badge = function (n) {
      document.querySelectorAll('a[href$="/cart"] > span, a[href="' + cartUrl + '"] > span').forEach(function (s) { if (/^\d+$/.test(s.textContent.trim() || '0')) s.textContent = n; });
    };

    var current = null;
    var render = function (cart) {
      current = cart;
      var items = cart.items || [];
      var handles = {}; items.forEach(function (i) { handles[i.handle] = true; });

      /* compare-at prices: draw now, refine once product JSON is loaded */
      var missing = items.filter(function (i) { return compareCache[i.variant_id] === undefined; }).map(function (i) { return i.handle; });
      if (missing.length) { Promise.all(missing.map(loadCompare)).then(function () { if (current === cart) paintLines(cart); }); }
      paintLines(cart);

      if (el.count) { el.count.textContent = cart.item_count; el.count.hidden = !cart.item_count; }
      badge(cart.item_count);
      el.empty.hidden = items.length > 0;
      el.foot.hidden = items.length === 0;
      if (el.subtotal) el.subtotal.textContent = fmt(cart.items_subtotal_price);

      if (el.bar) {
        if (threshold > 0) {
          var total = cart.items_subtotal_price, rest = Math.max(0, threshold - total);
          el.fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
          el.bar.classList.toggle('is-done', rest === 0);
          el.barText.textContent = rest === 0 ? L.bar_after : tpl(L.bar_before, { amount: fmt(rest) });
          el.bar.hidden = items.length === 0;
        } else { el.bar.hidden = true; }
      }

      if (el.upsell && el.upsellList) {
        var ups = (cfg.upsells || []).filter(function (u) { return !handles[u.handle]; });
        el.upsellList.innerHTML = ups.map(function (u) {
          return '<div class="wl-cart__up" data-wl-up="' + esc(u.handle) + '">' +
            '<a class="wl-cart__up-img" href="' + esc(u.url) + '"><img src="' + esc(u.image) + '" alt="" loading="lazy"></a>' +
            '<div class="wl-cart__up-info">' + (u.tag ? '<span class="wl-cart__up-tag">' + esc(u.tag) + '</span>' : '') +
            '<a class="wl-cart__up-name" href="' + esc(u.url) + '">' + esc(u.title) + '</a>' +
            '<span class="wl-cart__meta">' + esc(u.variant_title) + '</span>' +
            '<span class="wl-cart__up-price">' + fmt(u.price) + (u.compare > u.price ? '<s>' + fmt(u.compare) + '</s>' : '') + '</span></div>' +
            '<button type="button" class="wl-cart__up-add" data-wl-up-add="' + u.variant_id + '" aria-label="' + esc(L.add) + ' ' + esc(u.title) + '">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg><span class="wl-cart__up-add-txt">' + esc(L.add) + '</span></button></div>';
        }).join('');
        el.upsell.hidden = ups.length === 0;
      }
    };

    var paintLines = function (cart) {
      var items = cart.items || [];
      var saved = 0;
      el.items.innerHTML = items.map(function (i) {
        var cmp = compareCache[i.variant_id] || 0;
        if (i.selling_plan_allocation && i.selling_plan_allocation.compare_at_price > cmp) cmp = i.selling_plan_allocation.compare_at_price;
        var was = cmp * i.quantity;
        if (was > i.final_line_price) saved += was - i.final_line_price;
        var opts = (i.options_with_values || []).map(function (o) { return o.value; }).filter(Boolean).join(' · ');
        var plan = '';
        if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) {
          var m = planMeta(i.selling_plan_allocation.selling_plan.name);
          plan = '<span class="wl-cart__plan"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.3-5.7"></path><path d="M20 4v5h-5"></path></svg>' + esc(tpl(L.sub_line, { weeks: m.weeks, pct: m.pct })) + '</span>';
        } else if (L.once_line) { plan = '<span class="wl-cart__meta">' + esc(L.once_line) + '</span>'; }
        var img = i.featured_image && i.featured_image.url ? i.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : (i.image || '');
        return '<div class="wl-cart__line" data-wl-line="' + esc(i.key) + '">' +
          '<a class="wl-cart__img" href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</a>' +
          '<div class="wl-cart__info"><div class="wl-cart__row">' +
          '<a class="wl-cart__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          '<span class="wl-cart__price"><span>' + fmt(i.final_line_price) + '</span>' + (was > i.final_line_price ? '<span class="wl-cart__was">' + fmt(was) + '</span>' : '') + '</span></div>' +
          (opts ? '<span class="wl-cart__meta">' + esc(opts) + '</span>' : '') + plan +
          '<div class="wl-cart__ctrl"><div class="wl-cart__qty">' +
          '<button type="button" data-wl-qty="-1" aria-label="Réduire la quantité">−</button><output aria-live="polite">' + i.quantity + '</output>' +
          '<button type="button" data-wl-qty="1" aria-label="Augmenter la quantité">+</button></div>' +
          '<button type="button" class="wl-cart__rm" data-wl-qty="0" aria-label="' + esc(L.remove) + '"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"></path></svg></button>' +
          '</div></div></div>';
      }).join('');
      if (el.savings) { el.savings.hidden = saved <= 0; if (el.savingsVal) el.savingsVal.textContent = '-' + fmt(saved); }
    };

    /* ---------- interactions inside the drawer ---------- */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-wl-qty]');
      if (q) {
        var line = q.closest('[data-wl-line]'); if (!line || !current) return;
        var key = line.getAttribute('data-wl-line');
        var item = current.items.filter(function (i) { return i.key === key; })[0]; if (!item) return;
        var d = Number(q.getAttribute('data-wl-qty'));
        var qty = d === 0 ? 0 : Math.max(0, item.quantity + d);
        line.classList.add('is-busy');
        api('/cart/change.js', { id: key, quantity: qty }).then(render).catch(function () { line.classList.remove('is-busy'); toast(L.error); });
        return;
      }
      var u = e.target.closest('[data-wl-up-add]');
      if (u) {
        u.disabled = true;
        api('/cart/add.js', { items: [{ id: Number(u.getAttribute('data-wl-up-add')), quantity: 1 }] })
          .then(function () { u.classList.add('is-done'); u.innerHTML = esc(L.added); return refresh(); })
          .then(function () { if (el.body) el.body.scrollTo({ top: 0, behavior: 'smooth' }); })
          .catch(function () { u.disabled = false; toast(L.error); });
      }
    });

    /* ---------- one entry point for every add-to-cart in the theme ---------- */
    var closeNativeDialogs = function () {
      document.querySelectorAll('dialog[open]').forEach(function (d) { if (!d.closest('[data-wl-cart]')) { try { d.close(); } catch (e) {} } });
    };
    var addAndOpen = function (body, btn) {
      if (btn) { btn.disabled = true; btn.style.opacity = '.7'; btn.setAttribute('aria-busy', 'true'); }
      return api('/cart/add.js', body)
        .then(function () { return refresh(); })
        .then(function () { closeNativeDialogs(); open(); if (el.body) el.body.scrollTo({ top: 0 }); })
        .catch(function (err) { toast(err && err.message ? err.message : L.error); })
        .then(function () { if (btn) { btn.disabled = false; btn.style.opacity = '1'; btn.removeAttribute('aria-busy'); } });
    };
    window.wlCart = { open: function () { refresh().then(open, open); }, close: close, refresh: refresh, add: function (items) { return addAndOpen({ items: items }); } };

    /* 1) every <form action="/cart/add"> : PDP buy box (wl-pdp-buy), sticky bar (requestSubmit),
          carte cadeau (properties[...]), Horizon product-form-component (quick-add « Choose », recommandations) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return; /* let native validation / the form's own handler speak */
      var btn = form.querySelector('[type="submit"]');
      var fd = new FormData(form), body = {};
      fd.forEach(function (v, k) {
        if (k === 'form_type' || k === 'utf8' || k === 'sections' || k === 'sections_url' || k === 'product-id' || k === 'section-id' || /^options\[/.test(k)) return;
        var m = /^properties\[(.+)\]$/.exec(k);
        if (m) { body.properties = body.properties || {}; body.properties[m[1]] = v; return; }
        body[k] = v;
      });
      if (!body.id) return; /* unknown form: leave it to the browser */
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); /* Horizon / wl-app handlers must not run */
      body.id = Number(body.id); body.quantity = Number(body.quantity || 1);
      if (!body.selling_plan) delete body.selling_plan;
      addAndOpen(body, btn);
    }, true);

    /* 2) buttons with a variant id (home « Essentiels » cards data-wl-atc, any [data-wl-add] / [data-variant-id] button)
          and links to /cart/add?id=… */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var b = e.target.closest('[data-wl-atc],[data-wl-add],button[data-variant-id]');
      if (b && !b.closest('[data-wl-cart]')) {
        var vid = b.getAttribute('data-variant-id') || b.getAttribute('data-wl-add');
        if (!vid) return; /* no variant: wl-app.js redirects to the product page */
        /* wl-mobile.js (chargé avant nous) gère déjà [data-wl-atc] : ajout AJAX + clic synthétique sur /cart qui ouvre ce tiroir → ne pas ajouter deux fois */
        if (b.hasAttribute('data-wl-atc') && (window.__wlMobileInit || b.disabled)) return;
        e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
        var item = { id: Number(vid), quantity: Number(b.getAttribute('data-quantity') || 1) };
        var sp = b.getAttribute('data-selling-plan'); if (sp) item.selling_plan = Number(sp);
        var label = b.innerHTML;
        addAndOpen({ items: [item] }, b).then(function () { b.innerHTML = label; });
        return;
      }
      var a = e.target.closest('a[href*="/cart/add"]');
      if (a) {
        var u; try { u = new URL(a.href, location.origin); } catch (err) { return; }
        var id = u.searchParams.get('id'); if (!id) return;
        e.preventDefault(); e.stopPropagation();
        var it = { id: Number(id), quantity: Number(u.searchParams.get('quantity') || 1) };
        if (u.searchParams.get('selling_plan')) it.selling_plan = Number(u.searchParams.get('selling_plan'));
        addAndOpen({ items: [it] }, a);
      }
    }, true);

    /* 3) scripts that add via fetch then call the Horizon drawer (feeding calculator, apps):
          the Horizon drawer is replaced by ours — showDialog() opens this drawer, cart:update refreshes it */
    var hz = document.getElementById('cart-drawer');
    if (hz) { hz.showDialog = function () { refresh().then(open, open); }; hz.style.display = 'none'; }
    /* Horizon quick-add « Ajouter » (cartes /collections/all, recommandations) ajoute en fetch puis émet cart:update → on ouvre notre tiroir */
    document.addEventListener('cart:update', function () { refresh().then(function () { if (!onCartPage) { closeNativeDialogs(); open(); } }).catch(function () {}); });

    /* initial state (badge + drawer content ready before first open) */
    refresh().catch(function () {});
    /* ?cart=open → open on load (e.g. return from a link) */
    if (/[?&]cart=open/.test(location.search)) refresh().then(open, open);
  });
})();
